import { Injectable } from '@angular/core';

import { SessionStorageService } from '../../../core/services/web-storage';
import { PedidoFilter } from './pedido-filter';
import { PedidoFilterStorage } from './pedido-filter-storage';

/**
 * Service utilizado para armazenar os dados do filter dos pedidos no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class PedidoFilterStorageService {
    private key = 'pedidoFilter';

    constructor(private sessionStorageService: SessionStorageService) { }


    /** Obtem os dados do filtro armazenados */
    get(): PedidoFilterStorage {
        const data = this.sessionStorageService.getObject(this.key) as PedidoFilterStorage;
        if (data) {
            // Criando um Map com os campos filtrados e seus respectivos valores
            data.filterValues = new Map();
            const keys = Object.keys(data.filter);
            keys.forEach(key => data.filterValues.set(key, data.filter[key]));
        }

        return data;
    }

    /** Armazena os dados do filtro */
    set(filter: PedidoFilter) {
        const data = new PedidoFilterStorage(filter);
        this.sessionStorageService.setObject(this.key, data);
    }

    /** Remove os dados do filtro */
    remove() {
        this.sessionStorageService.remove(this.key);
    }

    /** Aplica o filtro armazenado no objeto do filtro informado */
    applyFilter(filter: PedidoFilter) {
        const filterStorage = this.get();
        if (filterStorage != null) {
            // Se possuir os dados, então setamos o filtro com os seus valores armazenados
            if (filter) {
                filterStorage.filterValues.forEach((value, key) => filter[key] = value);
            }
        }
    }
}
